export default 'https://tme.understood.org/assets/palpitations.1156cd98.lottie'